import React, {
    ReactElement,
    useEffect,
} from "react";
import {
    Route, Routes as BrowserRoutes,
    useLocation,
} from "react-router-dom";
import AuthRoute from "./components/AuthRoute";
import useRouting from "./contexts/Routing";
import AccountDetails from "./pages/account/details/AccountDetails";
import LoginWithToken from "./pages/account/login-with-token/LoginWithToken";
import Login from "./pages/account/login/Login";

import Administrator from "./pages/administrator/Administrator";
import AdministratorV3 from "./pages/administrator/AdministratorV3";

import SiteAdministrator from "./pages/site-admin/Administrator";

import AgentRoutes from "./pages/agent/AgentRoute";
import AnswerDetails from "./pages/answers/details/AnswerDetails";
import AnswerDetailsV3 from "./pages/answers/details-v3/index";

import AnswerList from "./pages/answers/list/AnswerList";
import ChannelInvite from "./pages/channel-invite/ChannelInvite";
import { Error404, ErrorDefault } from "./pages/error/Error";
import Homepage from "./pages/homepage/Homepage";
import TicketsV3 from "./pages/tickets-v3/TicketsV3";
import Contacts from "./pages/contacts/Contacts";
import OrganizationDetail from "./components/contacts/OrganizationDetail";
import UserDetail from "./components/contacts/UserDetail";
import ContactUsers from "./components/contacts/Users";
import Onboarding from "./pages/onboarding/Onboarding";
import WaitForDomain from "./pages/onboarding/wait-for-domain/WaitForDomain";
import Reports from "./pages/reports/Reports";
import ReportsV3 from "./pages/reports/ReportsV3";

import OnboardingTeamsInstalled from "./pages/onboarding/microsoft-teams/Installed";
import OnboardingTeamsInstalledChannel from "./pages/onboarding/microsoft-teams/InstalledChannel";

import Home from "./pages/homepage/Home";
import HomeV3 from "./pages/homepage/HomeV3";

import Actions from "./pages/actions/Actions";
import { useTheme } from "./contexts/Theme";
import Tickets from "./pages/tickets/Tickets";

function InternalError() {
    return <ErrorDefault message="Interal Error" />;
}

export default function Routes(): ReactElement {
    const { Paths } = useRouting();
    const theme = useTheme();

    return (
        <BrowserRoutes>

            <Route
                path={Paths.ANSWERS_NEW}
                element={(
                    <AuthRoute>
                        {
                            theme.isPageV3(Paths.ANSWERS_NEW) ? <AnswerDetailsV3 /> : <AnswerDetails />
                        }
                    </AuthRoute>
                )}
            />
            <Route
                path={Paths.ANSWERS_GET}
                element={theme.isPageV3(Paths.ANSWERS_GET) ? <AnswerDetailsV3 /> : <AnswerDetails />}
            />
            <Route
                path={Paths.ANSWERS_GET_VERSION}
                element={theme.isPageV3(Paths.ANSWERS_GET) ? <AnswerDetailsV3 /> : <AnswerDetails />}
            />
            <Route path={Paths.ANSWERS_LIST} element={<AnswerList />} />

            <Route path="agent/*" element={<AuthRoute><AgentRoutes /></AuthRoute>} />

            <Route
                path={Paths.TICKETS}
                element={(
                    <AuthRoute>
                        {
                            theme.isPageV3(Paths.TICKETS) ? <TicketsV3 /> : <Tickets />
                        }
                    </AuthRoute>
                )}
            />
            <Route
                path={Paths.TICKETS_CREATE}
                element={(
                    <AuthRoute>
                        {
                            theme.isPageV3(Paths.TICKETS) ? <TicketsV3 /> : <Tickets />
                        }
                    </AuthRoute>
                )}
            />
            <Route
                path={Paths.TICKETS_VIEW}
                element={(
                    <AuthRoute>
                        {
                            theme.isPageV3(Paths.TICKETS) ? <TicketsV3 /> : <Tickets />
                        }
                    </AuthRoute>
                )}
            />

            <Route path={Paths.CONTACTS} element={<AuthRoute><Contacts /></AuthRoute>} />
            <Route path={Paths.CONTACTS_ENTITY} element={<AuthRoute><Contacts /></AuthRoute>} />

            <Route
                path={Paths.REPORTS}
                element={(
                    <AuthRoute>
                        {
                            theme.isPageV3(Paths.REPORTS) ? <ReportsV3 /> : <Reports />
                        }
                    </AuthRoute>
                )}
            />
            <Route
                path={Paths.REPORTS_GET}
                element={(
                    <AuthRoute>
                        {
                            theme.isPageV3(Paths.REPORTS) ? <ReportsV3 /> : <Reports />
                        }
                    </AuthRoute>
                )}
            />

            <Route
                path={Paths.ORGANIZATION_USERS}
                element={(
                    <AuthRoute>
                        <Contacts
                            title="Users"
                        >
                            <ContactUsers />
                        </Contacts>
                    </AuthRoute>
                )}
            />
            <Route
                path={Paths.ORGANIZATIONS_ID}
                element={(
                    <AuthRoute>
                        <Contacts
                            title="Organizations"
                        >
                            <OrganizationDetail />
                        </Contacts>
                    </AuthRoute>
                )}
            />
            <Route
                path={Paths.ORGANIZATIONS_NEW}
                element={(
                    <AuthRoute>
                        <Contacts title="Organizations">
                            <OrganizationDetail />
                        </Contacts>
                    </AuthRoute>
                )}
            />
            <Route
                path={Paths.USERS_ID}
                element={(
                    <AuthRoute>
                        <Contacts
                            title="Users"
                        >
                            <UserDetail />
                        </Contacts>
                    </AuthRoute>
                )}
            />
            <Route
                path={Paths.USERS_NEW}
                element={(
                    <AuthRoute>
                        <Contacts title="Users">
                            <UserDetail />
                        </Contacts>
                    </AuthRoute>
                )}
            />
            <Route path={Paths.ONBOARDING} element={<AuthRoute><Onboarding /></AuthRoute>} />

            <Route path={Paths.HOME} element={theme.isPageV3(Paths.HOME) ? <HomeV3 /> : <Home />} />
            <Route path={Paths.WAIT_FOR_DOMAIN} element={<WaitForDomain />} />
            <Route path={Paths.ONBOARDING_STEP} element={<AuthRoute><Onboarding /></AuthRoute>} />
            <Route path={Paths.ONBOARDING_TEAMS_INSTALLED} element={<OnboardingTeamsInstalled />} />
            <Route path={Paths.ONBOARDING_TEAMS_INSTALLED_CHANNEL} element={<OnboardingTeamsInstalledChannel />} />

            <Route path={Paths.ACCOUNT_PROFLE} element={<AuthRoute><AccountDetails /></AuthRoute>} />
            <Route path={Paths.LOGIN} element={<Login />} />
            <Route path={Paths.LOGIN_WITH_TOKEN} element={<LoginWithToken />} />

            <Route
                path={Paths.ADMINISTRATOR_SETTING_ID_CHILD}
                element={(
                    <AuthRoute>
                        {theme.isPageV3(Paths.ADMINISTRATOR) ? <AdministratorV3 /> : <Administrator />}
                    </AuthRoute>
                )}
            />
            <Route
                path={Paths.ADMINISTRATOR_SETTING_ID}
                element={(
                    <AuthRoute>
                        {theme.isPageV3(Paths.ADMINISTRATOR) ? <AdministratorV3 /> : <Administrator />}
                    </AuthRoute>
                )}
            />
            <Route
                path={Paths.ADMINISTRATOR_SETTING}
                element={(
                    <AuthRoute>
                        {theme.isPageV3(Paths.ADMINISTRATOR) ? <AdministratorV3 /> : <Administrator />}
                    </AuthRoute>
                )}
            />
            <Route
                path={Paths.ADMINISTRATOR}
                element={(
                    <AuthRoute>
                        {theme.isPageV3(Paths.ADMINISTRATOR) ? <AdministratorV3 /> : <Administrator />}
                    </AuthRoute>
                )}
            />

            <Route path={Paths.SITE_ADMINISTRATOR_SETTING_ID} element={<AuthRoute><SiteAdministrator /></AuthRoute>} />
            <Route path={Paths.SITE_ADMINISTRATOR_SETTING} element={<AuthRoute><SiteAdministrator /></AuthRoute>} />
            <Route path={Paths.SITE_ADMINISTRATOR} element={<AuthRoute><SiteAdministrator /></AuthRoute>} />

            <Route path={Paths.CHANNEL_INVITE} element={<ChannelInvite />} />

            <Route path={Paths.ACTION_FEEDBACK} element={<Actions />} />
            <Route path={Paths.ACTION_DEFLECTION} element={<Actions />} />

            <Route path={Paths.DEFAULT} element={<Homepage />} />
            <Route path={Paths.ERROR_404} element={<Error404 />} />
            <Route path={Paths.ERROR_INTERNAL} element={<InternalError />} />

            <Route path="*" element={<Homepage />} />

        </BrowserRoutes>
    );
}
